import Link from "next/link";
import { ChangeEvent } from "react";

interface SecondaryActionsProps {
    rememberMe: boolean
    onCheckBoxChange: (e: ChangeEvent<HTMLInputElement>) => void
}

export default function SecondaryActions(props: SecondaryActionsProps) {
    const { rememberMe, onCheckBoxChange } = props;

    return (
        <div className="flex items-center justify-between my-6">
            <div className="flex items-center">
                <input
                    id="rememberMe"
                    checked={rememberMe}
                    onChange={onCheckBoxChange}
                    type="checkbox"
                    className="text-black focus:ring-2 focus:ring-gray-300"
                />
                <label htmlFor="remember" className="ml-2 text-gray-600">
                    Remember me
                </label>
            </div>
            <Link href="/forgot-password" className="text-[#93885B] hover:text-gray-800">
                Forgot password
            </Link>
        </div>
    );
}